import React from "react";
import { Form } from "react-bootstrap";
import emailjs from "emailjs-com";
import "../../Contact/Contact.css";

const HomeContact = () => {
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "gmail",
        "to-my-portfolio",
        e.target,
        "user_FWGh5im342NwwbkSPuK4P"
      )
      .then(
        (result) => {
          alert("Email send");
        },
        (error) => {
          alert(error.message);
        }
      );
    e.target.reset();
  };

  return (
    <main className="contact">
      <section className="container-fluid my-5">
        <div className="d-flex flex-column align-items-center">
          <h1>
            <span className="text-danger">Contact</span> Me
          </h1>
          <div className="underLine"></div>
        </div>
        {/* ----------------- new --------------- */}
        <div className="row my-5">
          <div className="col-md-4">
            <div className="contact_box phone">
              <div className="d-flex">
                <h1>P</h1>
                <div className="">
                  <h5>+8801748008121</h5>
                  <h6>Open hour (8:00 AM - 10:00 PM)</h6>
                </div>
              </div>
            </div>

            <div className="contact_box email">
              <div className="d-flex">
                <h1>E</h1>
                <div className="">
                  <a href="mailto: abu.horain20@gmail.com">
                    <h5 className=""> abu.horain20@gmail.com</h5>
                  </a>
                  <h6>Feel free to text me any time</h6>
                </div>
              </div>
            </div>

            <div className="contact_box location">
              <div className="d-flex">
                <h1>L</h1>
                <div className="">
                  <h5>Bangladesh</h5>
                  <h6>Feni District, Chittagong, Bangladesh</h6>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <Form onSubmit={sendEmail} className=" p-3 row">
              <div className="col-md-6">
                <Form.Group>
                  <Form.Label>Your Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Type your full name"
                    required
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Your Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="name@gmail.com"
                    required
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Your Subject</Form.Label>
                  <Form.Control
                    type="text"
                    name="subject"
                    placeholder="Type your Subject"
                    required
                  />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group>
                  <Form.Label>Free feel to message</Form.Label>
                  <Form.Control
                    type="text"
                    name="message"
                    as="textarea"
                    placeholder="Type message..."
                    rows={8}
                    required
                  />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <button className="contact_btn" type="submit">
                  SEND
                </button>
              </div>
            </Form>
          </div>
        </div>
      </section>
    </main>
  );
};

export default HomeContact;
